/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Remind_Email_WhenInputs */

const en_portal_remind_email_when = /** @type {(inputs: Portal_Remind_Email_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email · 7:00`)
};

const pl_portal_remind_email_when = /** @type {(inputs: Portal_Remind_Email_WhenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail · 7:00`)
};

/**
* | output |
* | --- |
* | "Email · 7:00" |
*
* @param {Portal_Remind_Email_WhenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_remind_email_when = /** @type {((inputs?: Portal_Remind_Email_WhenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Remind_Email_WhenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_remind_email_when(inputs)
	return en_portal_remind_email_when(inputs)
});